<template>
  <div class="invoice-dense-tab">
    <app-collapse class="mb-1 invoice-dense-filters">
      <app-collapse-item title="Filters">
        <template #header>
          <span class="invoice-dense-filters__title">
            <feather-icon icon="FilterIcon" size="15" />
            <span>Filters</span>
          </span>
        </template>
        <div class="p-2">
          <b-row>
            <b-col cols="12" sm="6" md="3">
              <b-form-group label="Client">
                <b-form-select v-model="filters.client" :options="clientSelectOptions" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="3" class="d-flex align-items-end">
              <b-button variant="primary" size="sm" @click="$emit('apply', { ...filters })" class="mr-2">Apply</b-button>
              <b-button variant="outline-secondary" size="sm" @click="clearFilters">Clear</b-button>
            </b-col>
          </b-row>
        </div>
      </app-collapse-item>
    </app-collapse>

    <div class="invoice-dense-panel">
      <b-form @submit.prevent="$emit('upload', { ...form })">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label="Select Invoice" class="mb-1">
              <b-form-select
                v-model="form.invoice_id"
                :options="invoiceSelectOptions"
                size="sm"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group label="Upload Calculation Sheet" class="mb-1">
              <b-form-file
                v-model="form.file"
                placeholder="Choose Excel file..."
                drop-placeholder="Drop file here..."
                accept=".xls,.xlsx,.csv"
                @change="onFileChange"
              />
              <small class="text-muted">Accepted: Excel (.xls, .xlsx) or CSV. Required columns: Candidate, Days, Rate, Amount</small>
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="preview.length > 0" class="mt-1">
          <div class="invoice-dense-toolbar">
            <div class="invoice-dense-toolbar__meta">Preview · {{ preview.length }} row{{ preview.length === 1 ? '' : 's' }}</div>
          </div>
          <div class="invoice-dense-table-wrap">
            <b-table :items="preview" :fields="previewFields" hover responsive small class="invoice-dense-table mb-0" show-empty>
              <template #empty>
                <div class="invoice-dense-state">
                  <h6 class="mb-0">No preview rows</h6>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <b-row class="mt-1">
          <b-col cols="12" class="text-right">
            <b-button variant="success" size="sm" type="submit" class="invoice-dense-submit-btn" :disabled="!form.invoice_id || !form.file || uploading">
              <b-spinner v-if="uploading" small class="mr-1" />
              Upload &amp; Process Sheet
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormSelect, BFormFile, BTable, BButton, BSpinner } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { resolveInvoiceApiKey } from '@/utils/invoice-api-key'

export default {
  name: 'ContractualBillingTab',
  components: { BRow, BCol, BForm, BFormGroup, BFormSelect, BFormFile, BTable, BButton, BSpinner, AppCollapse, AppCollapseItem },
  props: {
    invoices: { type: Array, default: () => [] },
    previewFields: { type: Array, default: () => [] },
    clients: { type: Array, default: () => [] },
    uploading: Boolean,
    initialFilters: {
      type: Object,
      default: () => ({ client: null })
    }
  },
  data() {
    return {
      form: { invoice_id: null, file: null },
      preview: [],
      filters: { client: this.initialFilters.client || null }
    }
  },
  computed: {
    clientSelectOptions() {
      return [
        { value: null, text: 'Select Client' },
        ...(this.clients || []).map(c => ({
          value: c.title != null ? c.title : (c.text != null ? c.text : c.value),
          text: c.text || c.title || String(c.value ?? '')
        }))
      ]
    },
    invoiceSelectOptions() {
      return [
        { value: null, text: 'Select Invoice' },
        ...(this.invoices || []).map(inv => ({
          value: resolveInvoiceApiKey(inv) || inv.id,
          text: `${inv.invoice_id || inv.invoice_number || 'N/A'} - ${inv.client || 'N/A'} (${inv.status || 'N/A'})`
        }))
      ]
    }
  },
  methods: {
    onFileChange(event) {
      this.$emit('file-change', event)
    },
    updatePreview(rows) { this.preview = Array.isArray(rows) ? rows : [] },
    resetForm() {
      this.form = { invoice_id: null, file: null }
      this.preview = []
    },
    clearFilters() {
      this.filters = { client: null }
      this.$emit('apply', { ...this.filters })
    }
  }
}
</script>

<style lang="scss">
@import './invoice-dense-tab.scss';
</style>
